export default __webpack_public_path__ + "static/media/sub_notification.9cb24844.aac";